export default "__VITE_PUBLIC_ASSET__2e4c4bda__"